import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../App';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/img/logo.png';
import { Link } from 'react-router-dom';
import { LoadingOverlay } from '../components/loading';
import LoginPage from '../components/login/loginPage';
import ResetPasswordPage from '../components/login/resetPasswordPage';

export default function ResetPassword() {
  return (
    <ResetPasswordPage />
  )
}
